module.exports = __webpack_public_path__ + "static/student-d9888aaa87ca6bd456bcb455149ec4a9.jpg";